import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { WebSocketProvider } from './Context/SocketProvider.tsx'
import { Route, BrowserRouter, Routes } from 'react-router-dom';
import App from './App.tsx'
import { DonoTrainPage } from './pages/DonoTrain.tsx';
import { ProtectedRoute } from './Components/ProtectedRoute/ProtectedRoute.tsx';
import { Login } from './pages/Login.tsx';
import { AuthProvider } from './Context/AuthProvider.tsx';
import { DonoTrainOBSWidget } from './obs-widgets/DonoTrainOBSWidget.tsx';
import { Goal } from './pages/Goal.tsx';
import { NewGoal } from './pages/NewGoal.tsx';
import { OBSGoalWidget } from './obs-widgets/OBSGoalWidget.tsx';
import { Home } from './pages/Home.tsx';
import { SubathonPage } from './pages/Subathon.tsx';
import { OBSSubathonWidget } from './obs-widgets/OBSSubathonWidget.tsx';
import { Session } from './pages/Session.tsx';
import { DonoTrainGoalsWidget } from './obs-widgets/DonoTrainGoalsWidget.tsx';
import { GradientCreator } from './Components/GradientCreator/GradientCreator.tsx';
import { Kofi } from './pages/Kofi.tsx';
import { ChatBot } from './pages/ChatBot.tsx';
import { StreamElements } from './pages/StreamElements.tsx';
import { Tipeee } from './pages/Tipeee.tsx';
import { Twitch } from './pages/Twitch.tsx';
import { ErrorBoundary } from "react-error-boundary";

let localStorageToken = undefined;
try {
  localStorageToken = globalThis.localStorage.getItem("remembered-token") ?? undefined;
  if (localStorageToken) {
    localStorageToken = JSON.parse(localStorageToken);
  }
} catch (error) {
  console.error("Error accessing localStorage:", error);
  localStorageToken = undefined;
}
const urlToken = new URLSearchParams(globalThis.location.search).get('token') ?? undefined;

const initialToken = urlToken ?? localStorageToken ?? undefined;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider initialToken={initialToken}>
        <WebSocketProvider>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route element={<ProtectedRoute />}>
                <Route path="/obs-widgets">
                  <Route path="donotrain" element={
                    <ErrorBoundary fallback={null}> 
                      <DonoTrainOBSWidget />
                    </ErrorBoundary>
                  } />
                  <Route path="donotrain-goals" element={
                    <ErrorBoundary fallback={null}>
                      <DonoTrainGoalsWidget />
                    </ErrorBoundary>
                  } />
                  <Route path="goal">
                    <Route path=":id" element={
                      <ErrorBoundary fallback={null}>
                        <OBSGoalWidget />
                      </ErrorBoundary>
                    } />
                  </Route>
                  <Route path="subathons">
                    <Route path=":id" element={
                      <ErrorBoundary fallback={null}>
                        <OBSSubathonWidget />
                      </ErrorBoundary>
                    } />
                  </Route>
                </Route>
                <Route path="/" element={<App />}>
                  <Route path="" element={<Home />} />
                  <Route path="home" element={<Home />} />
                  <Route path="gradient" element={<GradientCreator />} />
                  <Route path="session" element={<Session />} />
                  <Route path="widgets/donotrain" element={<DonoTrainPage />} />
                  <Route path="goals">
                    <Route path="new" element={<NewGoal />} />
                    <Route path=":id" element={<Goal/>} />
                  </Route>
                  <Route path="subathons">
                    <Route path=":id" element={<SubathonPage/>} />
                  </Route>
                  <Route path="settings/twitch" element={<Twitch/>}/>
                  <Route path="settings/kofi" element={<Kofi/>}/>
                  <Route path="settings/streamelements" element={<StreamElements/>}/>
                  <Route path="settings/tipeee" element={<Tipeee/>}/>
                  <Route path="settings/chatbot" element={<ChatBot/>}/>
                </Route>
              </Route>
            </Routes>
        </WebSocketProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
)
